import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'
import CurrentAccount from '../../models/CurrentAccount'
import ElectronicStock from '../../models/ElectronicStock'

export interface CurrentAccountListState extends PaginatedApiState {
  currentAccounts?: CurrentAccount[]
  electronicStock?: ElectronicStock[]
}

const CurrentAccountList = (state: CurrentAccountListState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<CurrentAccountListState>('CURRENT_ACCOUNT_LIST')(state, action)
  }
}

export default CurrentAccountList
